import { render, staticRenderFns } from "./InvalidCross.vue?vue&type=template&id=6e6b10f1&"
var script = {}
import style0 from "./InvalidCross.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/InvalidCross.vue
// module id = null
// module chunks = 